$(document).ready(function () {

	var myWindowURL = 'http://maryknollsisters.org/light-a-candle';
	var myWindowTitle = 'I prayed with the Maryknoll Sisters.';
	var myWindowDescription = 'Today I lit a candle on the Maryknoll Sisters virtual votive chapel and said a prayer. Please join us in prayer, together we are making God\'s love visible.';
	var myWindowPicture = 'http://i63.tinypic.com/1z3o0vo.jpg';

	
	

	if(window.location.href.indexOf('World+Peace') > -1) {
		myWindowTitle = 'I prayed for World Peace with the Maryknoll Sisters.';
		$('.share-title').text(myWindowTitle);
		$('.facebook-button').attr('href', 'https://www.facebook.com/sharer/sharer.php?u='+myWindowURL+'&title='+myWindowTitle+'&description='+myWindowDescription+'&picture='+myWindowPicture);
	}

	if(window.location.href.indexOf('Myself') > -1) {
		myWindowTitle = 'I prayed for myself with the Maryknoll Sisters.';
		$('.share-title').text(myWindowTitle);
		$('.facebook-button').attr('href', 'https://www.facebook.com/sharer/sharer.php?u='+myWindowURL+'&title='+myWindowTitle+'&description='+myWindowDescription+'&picture='+myWindowPicture);
	}

	if(window.location.href.indexOf('Sympathy') > -1) {
		myWindowTitle = 'I prayed for sympathy with the Maryknoll Sisters.';
		$('.share-title').text(myWindowTitle);
		$('.facebook-button').attr('href', 'https://www.facebook.com/sharer/sharer.php?u='+myWindowURL+'&title='+myWindowTitle+'&description='+myWindowDescription+'&picture='+myWindowPicture);
	}

	if(window.location.href.indexOf('The+Poor') > -1) {
		myWindowTitle = 'I prayed for the poor with the Maryknoll Sisters.';
		$('.share-title').text(myWindowTitle);
		$('.facebook-button').attr('href', 'https://www.facebook.com/sharer/sharer.php?u='+myWindowURL+'&title='+myWindowTitle+'&description='+myWindowDescription+'&picture='+myWindowPicture);
	}

	if(window.location.href.indexOf('The+Sick') > -1) {
		myWindowTitle = 'I prayed for the sick with the Maryknoll Sisters.';
		$('.share-title').text(myWindowTitle);
		$('.facebook-button').attr('href', 'https://www.facebook.com/sharer/sharer.php?u='+myWindowURL+'&title='+myWindowTitle+'&description='+myWindowDescription+'&picture='+myWindowPicture);
	}

	if(window.location.href.indexOf('The+Hungry') > -1) {
		myWindowTitle = 'I prayed for the hungry with the Maryknoll Sisters.';
		$('.share-title').text(myWindowTitle);
		$('.facebook-button').attr('href', 'https://www.facebook.com/sharer/sharer.php?u='+myWindowURL+'&title='+myWindowTitle+'&description='+myWindowDescription+'&picture='+myWindowPicture);
	}

	if(window.location.href.indexOf('Hope') > -1) {
		myWindowTitle = 'I prayed for hope with the Maryknoll Sisters.';
		$('.share-title').text(myWindowTitle);
		$('.facebook-button').attr('href', 'https://www.facebook.com/sharer/sharer.php?u='+myWindowURL+'&title='+myWindowTitle+'&description='+myWindowDescription+'&picture='+myWindowPicture);
	}


});


// WEBPACK FOOTER //
// ./theme_components/js/share-a-prayer.js